module.exports = __webpack_public_path__ + "static/VorlageBriefpapier-1-0c0c50e34adfaadef5768735d66a4e1a.png";